import { render, staticRenderFns } from "./DeleteProspectHandler.vue?vue&type=template&id=df04f8ea&scoped=true"
import script from "./DeleteProspectHandler.vue?vue&type=script&lang=js"
export * from "./DeleteProspectHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df04f8ea",
  null
  
)

export default component.exports